// import { AxiosError } from 'axios';
import { FormEvent } from 'react';

import { useStore } from '../../context/Store';

import { API } from '../../services/api';
import { RefuellingData } from '../../types/utils/RefuellingData';

export default () => {
  const {
    plate,
    voucherId,
    associadoId,
    selectedFuel,
    valueRefueling,
    changeNotification,
    changeInitialState,
    changeLoading,
  } = useStore();

  const postInformation = async (event: FormEvent) => {
    event.preventDefault();

    const gasId = localStorage.getItem('idPosto');

    if (!valueRefueling || !selectedFuel) {
      changeNotification(
        'error',
        'A seleção do combustível e o preenchimento do valor, são necessários para concluir a venda.',
      );
      return;
    }

    try {
      changeLoading(true);

      if (voucherId) {
        const args = {
          voucherId,
          idPosto: gasId,
          combustivelId: selectedFuel,
        };

        const res = await API.post<RefuellingData>(
          '/api/v1/Voucher/abastecimento',
          args,
        );

        // Mark as voucher and ignore HTML comprovante
        const voucherData = { ...res.data, isVoucher: true };
        delete voucherData.comprovante;
        changeNotification('success', 'Abastecimento realizado!', voucherData);
        localStorage.removeItem('voucherReceipt');

        changeLoading(false);
        changeInitialState();

        return;
      }

      const args = {
        totalValorAbastecido: valueRefueling
          .replaceAll('.', '')
          .replaceAll(',', '.'),
        postoId: gasId,
        combustivellId: selectedFuel,
        associadoId: associadoId,
        veiculo: {
          nome: 'string',
          placa: plate,
        },
      };

      const res = await API.post<RefuellingData>(
        '/api/v1/Associado/abastecimento',
        args,
      );

      changeNotification('success', 'Abastecimento realizado!', res.data);
      changeLoading(false);
      changeInitialState();
    } catch (error: unknown) {
      changeLoading(false);

      if (error && typeof error === 'object' && 'response' in error) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const axiosError = error as any;
        const errors = axiosError.response?.data?.errors;

        if (errors) {
          changeNotification('error', errors.join('\n'));
        } else {
          changeNotification('error', 'Erro no aplicativo, tente novamente!.');
        }
      } else {
        changeNotification('error', 'Erro no aplicativo, tente novamente!.');
      }
    }
  };

  return {
    postInformation,
  };
};
